import { Component, OnInit } from '@angular/core';
import { LayoutSettingsService } from 'app/core/services/layout-settings.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  layoutType!: string;
  constructor(private _layout: LayoutSettingsService) {}

  ngOnInit(): void {
    this._layout.setDefaultOptions();
  }
}
